import React from "react";
import styles from "./buttonGroup.module.scss";
import { Button } from "@kunduz/ui-atoms";
import Link from "next/link";
import classNames from "classnames";

export const ButtonGroup = (props: Props) => {
  const { buttons, isSticky, title } = props;

  const onCtaClicked = () => {};

  return (
    <div className={styles.container}>
      {title && <div className={styles.title}>{title}</div>}
      {buttons?.length > 0 && (
        <div className={styles.buttonsContainer}>
          {buttons.map((button, i) => (
            <Button
              key={i}
              color="tutorGreen"
              as={Link}
              href={button.url}
              onClick={onCtaClicked}
              className={classNames(styles.button, {
                [styles.primary]: button.type === "primary",
                [styles.secondary]: button.type === "secondary",
              })}
            >
              {button.image && <img src={button.image} />}
              {button.label}
            </Button>
          ))}
        </div>
      )}
    </div>
  );
};

interface Props {
  title: string;
  isSticky: boolean;
  buttons: {
    image: string;
    label: string;
    target: string;
    type: string;
    url: string;
  }[];
}
